// External libraries
import { css } from '@emotion/core';

// Internal modules
import { HEADER_COLOR } from '@/styles';

const appSectionStyles = css`
  max-width: 390px;
`;

const appStyles = css`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;

const valuePropHeaderStyles = css`
  color: ${HEADER_COLOR};
  font-size: 25px;
  font-weight: 300;
  line-height: 1.2;
  margin: 15px 0 10px;
`;

const valuePropSubHeaderStyles = css`
  font-size: 14px;
  font-weight: 400;
  line-height: 1.2;
  margin: 5px 0;
`;

export {
  appSectionStyles,
  appStyles,
  valuePropHeaderStyles,
  valuePropSubHeaderStyles,
};
